import { FiHelpCircle } from 'react-icons/fi'
import { NavLink } from 'react-router-dom'

import Tooltip from '~/components/Tooltip'
import { Badge } from '~/components/UI/Badge'
import { isReadOnly } from '~/helpers'

const MainInfo: React.FC<{ data: Placement }> = ({ data }) => (
  <NavLink to={isReadOnly() ? null : `${data.id}/edit/`}>
    <div className="d-inline-flex align-items-start flex-column gap-1 lh-1">
      <header className="id d-flex align-items-center">
        <Badge className="name m-0">{data.name}</Badge>
        <Tooltip
          icon={<FiHelpCircle />}
          text={'Esse valor é usado nas requisições de anúncios e é único.'}
        />
      </header>

      {data?.full_name && (
        <strong className="text-primary fullName fs-6">{data.full_name}</strong>
      )}
      {data?.description && (
        <small className="description">{data.description}</small>
      )}
    </div>
  </NavLink>
)

export default MainInfo
